import "./style.scss";

const BoxError = (props, { children }) => (
    <div className="box-error">
        <ul>
            {props.children}
        </ul>
    </div>
);

export default BoxError;
